module.exports = __webpack_public_path__ + "49ebf715eb73e64ce4d3bd359e5f0728.jpg";